var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopeProfileRead = function SvgScopeProfileRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    clipPath: "url(#scope-profile-read_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.544 12.959A2.67 2.67 0 0 1 6 11.333h.402m8.167-2.189q.097-.559.098-1.144a6.667 6.667 0 1 0-7.784 6.573m3.784-8.24a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.094 12.755c-.049-.077-.073-.116-.086-.175a.4.4 0 0 1 0-.16c.013-.06.037-.098.086-.175C8.494 11.61 9.685 10 11.5 10s3.006 1.609 3.406 2.245c.049.077.073.116.086.175.01.045.01.115 0 .16-.013.06-.037.098-.086.175-.4.636-1.591 2.245-3.406 2.245s-3.006-1.609-3.406-2.245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.571c.59 0 1.067-.48 1.067-1.071 0-.592-.478-1.071-1.067-1.071-.59 0-1.067.48-1.067 1.071 0 .592.478 1.071 1.067 1.071"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "scope-profile-read_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgScopeProfileRead;